/*
 * FAQ Search
 */

// define faq sections
const faqSections = $('.section--expandable-items'); 

$('.faq-search input').on('keyup', function(e) {
	// initiate search
	search($(this).val()); 	
});


function search(word) {

	// lowercase search term(s)
	let term = word.toLowerCase(); 

	// iterate over faq sections
	faqSections.each(function() {
		let items = $(this).find('.item');
		let hiddenElements = 0;
		
		// iterate over faq items 
		items.each( function() {

			// define faq item title and content
			let titleText = $(this).find('.item__toggle-text').text(); 
			let contentText = $(this).find('.item__content .content').text();
			let title = $.trim(titleText).toLowerCase();
			let content = $.trim(contentText).toLowerCase();

			// check if title or content matches search term
			if (title.includes(term) || content.includes(term)) {
				$(this).show();
			} else {
				$(this).hide(); 
				hiddenElements++;
			}
		})

		if (items.length == hiddenElements) {
			// hide whole section if no faq items match with search result
			$(this).hide(); 
		} else {
			$(this).show();
		}
	});	
}